import { useMemo } from 'react';

import { getMsUntilNextSecond } from '#shared';

import type { SimpleStatistics } from '#entities/types';

import { usePollingQuery, useAggregateRefetch } from '#shared/api';
import type { PollingQueryResult } from '#shared/api';

import { useGetSimpleStatisticsQuery } from '../simpleStatistics.api';

const TARGET_SECOND = 5;

const getSimpleStatisticsDelay = () => getMsUntilNextSecond(TARGET_SECOND);

export const useQuerySimpleStatistics =
  (): PollingQueryResult<SimpleStatistics | null> => {
    const queryResult = useGetSimpleStatisticsQuery(undefined, {
      pollingInterval: 0,
    });

    const { getDelay, refetchSignal } = useAggregateRefetch(
      'simpleStatistics',
      getSimpleStatisticsDelay,
    );
    const pollingResult = usePollingQuery(queryResult, {
      getDelay,
      refetchSignal,
    });

    return useMemo(
      () => ({
        data: pollingResult.data?.data ?? null,
        generatedAt: pollingResult.data?.generatedAt ?? null,
        validation: null, // TODO: add validation when schema validation is added
        isLoading: pollingResult.isLoading,
        isFetching: pollingResult.isFetching,
        isError: pollingResult.isError,
        error: pollingResult.error,
        lastSentTime: pollingResult.lastSentTime,
        lastReceiveTime: pollingResult.lastReceiveTime,
      }),
      [pollingResult],
    );
  };
